import React from 'react';
import { Radio, FormDashboardInput as Input } from '../../../components';
import FileDropzone from './file-dropzone';

const FormMethodType = ({form, handleInput}) => {
  const handleFileDropzone = (files) => {
    const file = files[0]
    console.log(file)

    if(file){
      handleInput({
        target: {
          name: 'blob',
          value: {
            url: URL.createObjectURL(file),
            name: file.name,
            type: file.type
          }
        }
      })
    }
  }

  return (
    <div>
      <div className="flex items-center mb-4">
        <div>
          <Radio
            name="method_type"
            id="method_type_embed"
            value="embed"
            label="Embed"
            className="mr-5 mb-2 lg:mb-0"
            form={form}
            onChange={handleInput}
          />
        </div>
        <div>
          <Radio
            name="method_type"
            id={`type_upload`}
            value="upload"
            label="Upload"
            className="mr-5 mb-2 lg:mb-0"
            form={form}
            onChange={handleInput}
          />
        </div>
      </div>

      {
        form.method_type === 'embed' &&
        <div className="pt-4">
          <Input
            name="embedLink"
            className="w-full"
            placeholder="Example: https://embedsource.com/file-slug-goes-here.pdf"
            defaultValue={form.embedLink}
            onChange={(e) => {e.persist(); handleInput(e)}}
          />
        </div>
      }
      {
        form.method_type === 'upload' &&
        <FileDropzone accept={form.type} onChange={handleFileDropzone} />
      }
    </div>
  )
}

export { FormMethodType }
